import { useModules } from '@entities/common';
import type React from 'react';
import { Navigate, Routes } from 'react-router-dom';
import { Route } from 'react-router-dom';

import { useUser } from '@shared/hooks';

import { ChoosePeriod } from './choose-period-modal';
import { ConsultationModal } from './consultation-modal';
import { ConsultationsMain } from './consultations-main-page';
import { MoveSummaryModal } from './move-summary-modal';

export const Consultations: React.FC = () => {
	// const { user } = useUser();
	const { moduleByType } = useModules();
	const scheduleModule = moduleByType('schedule');
	// const redirectToSchedules = !!(user?.is_coach && scheduleModule);

	return (
		<Routes>
			<Route path=":code">
				<Route index element={<ConsultationsMain />} />
				<Route path="choose-period/:moveParams" element={<ChoosePeriod />} />
				<Route path="consultation-move/:moveParams" element={<MoveSummaryModal />} />
				<Route path="consultation">
				{/*	<Route*/}
				{/*		index*/}
				{/*		element={*/}
				{/*			// redirectToSchedules ? (*/}
				{/*			// 	<Navigate to={`/schedule/${scheduleModule?.code}/:consultationId`} replace />*/}
				{/*			// ) : (*/}
				{/*				<>Консультации</>*/}
				{/*			// )*/}
				{/*		}*/}
				{/*	/>*/}
					<Route path=":consultationId" element={<ConsultationModal />} />
				</Route>
			</Route>
		</Routes>
	);
};
